module.exports = __webpack_public_path__ + "img/kalender-hover.2a4e2ac0.svg";